import type { ChatAppResponse } from "@/api/models"

/** True when a saved answer was produced by Deep Explorer. */
export function isDeepExplorerAnswer(response: ChatAppResponse | undefined): boolean {
  const context = response?.context as Record<string, unknown> | undefined
  if (!context) return false
  return context.deep_activity_events !== undefined || context.source === "explorer_deep"
}

/**
 * Whether a chat opened from history should be in Deep mode: only when its
 * latest saved answer came from Deep Explorer. Earlier Deep answers don't
 * count, so a chat the user switched back to plain mode reopens in plain mode
 * (#3060).
 */
export function shouldOpenSessionInDeepMode(
  messages: readonly (readonly [string, ChatAppResponse])[] | undefined
): boolean {
  return isDeepExplorerAnswer(messages?.at(-1)?.[1])
}
